'use client';

import { Link } from '@mokoboko/components';

import { track, AnalyticsEvent } from '@/lib/analytics/tracker';

export const DirectionsLink = ({
  href,
  className,
}: {
  href: string;
  className?: string;
}) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    size="sm"
    className={className}
    onClick={() => track({ event: AnalyticsEvent.DIRECTIONS_CLICKED })}
  >
    Get directions
  </Link>
);
